import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded'
import PrintRoundedIcon from '@mui/icons-material/PrintRounded'
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
import {
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material'
import TableCell from '@mui/material/TableCell'
import { teenagerRecordFunctionalities } from 'utils/helpers/funcionalidades'
import { TableHeadCell } from 'pages/SearchTeenager/styles'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { SummaryTeenagerType } from 'types/search-teenager.type'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import dayjs from 'dayjs'

type TableDataProps = {
  data: SummaryTeenagerType[]
  onHasPermission: (permission: string) => boolean
}

const TableData: React.FC<TableDataProps> = ({ data, onHasPermission }) => {
  const navigate = useNavigate()

  const handleVisualize = (teenagerId: number): void => navigate(`/ficha-adolescente/${teenagerId}`)

  const handleEdit = (teenagerId: number): void =>
    navigate(`/ficha-adolescente/${teenagerId}/editar`)

  const handleExport = (teenagerId: number): void =>
    navigate(`/ficha-adolescente/${teenagerId}/exportar`)

  const handlePrint = (teenagerId: number): void =>
    navigate(`/ficha-adolescente/${teenagerId}/imprimir`)

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeadCell>Nome do adolescente</TableHeadCell>
            <TableHeadCell>Nome Social</TableHeadCell>
            <TableHeadCell align='center'>Data de nascimento</TableHeadCell>
            <TableHeadCell align='center'>Ações</TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow hover key={item.id}>
              <TableCell>{item.nome}</TableCell>
              <TableCell>{item.nomeSocial}</TableCell>
              <TableCell align='center'>
                {dayjs(item.dataNascimento, 'YYYY-MM-DD').isValid()
                  ? dayjs(item.dataNascimento).format('DD/MM/YYYY')
                  : 'Não informado.'}
              </TableCell>
              <TableCell align='center'>
                {onHasPermission(teenagerRecordFunctionalities.visualizar) && (
                  <Tooltip title='Visualizar'>
                    <IconButton
                      color='info'
                      aria-label='visualize'
                      onClick={() => handleVisualize(item.id)}
                    >
                      <RemoveRedEyeRoundedIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
                {onHasPermission(teenagerRecordFunctionalities.editar) && (
                  <Tooltip title='Editar'>
                    <IconButton
                      color='info'
                      aria-label='visualize'
                      onClick={() => handleEdit(item.id)}
                    >
                      <EditRoundedIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
                {onHasPermission(teenagerRecordFunctionalities.imprimir) && (
                  <Tooltip title='Exportar'>
                    <IconButton
                      color='info'
                      aria-label='Exportar'
                      onClick={() => handleExport(item.id)}
                    >
                      <DownloadRoundedIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
                {onHasPermission(teenagerRecordFunctionalities.imprimir) && (
                  <Tooltip title='Imprimir'>
                    <IconButton
                      color='info'
                      aria-label='print'
                      onClick={() => handlePrint(item.id)}
                    >
                      <PrintRoundedIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableData
